/* Ride and Thrive — theme.js
   Everything is written as an init(scope) so it can be re-run when Shopify
   re-renders a single section in the theme editor. */
(function () {
  'use strict';

  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var inEditor = !!(window.Shopify && window.Shopify.designMode);

  /* --- scroll reveal ------------------------------------------------ */
  function initReveal(scope) {
    var targets = scope.querySelectorAll('.reveal:not([data-revealed])');
    if (!targets.length) return;

    // In the theme editor, never hide anything — merchants edit what they see.
    if (inEditor || reduced || !('IntersectionObserver' in window)) {
      targets.forEach(function (el) {
        el.dataset.revealed = 'true';
        el.classList.add('is-visible');
      });
      return;
    }

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -6% 0px' });

    targets.forEach(function (el) {
      el.dataset.revealed = 'true';
      io.observe(el);
      // Safety net: if anything goes wrong, show it rather than hide it.
      window.setTimeout(function () { el.classList.add('is-visible'); }, 2500);
    });
  }

  /* --- quantity stepper --------------------------------------------- */
  function initQty(scope) {
    scope.querySelectorAll('[data-qty]:not([data-init])').forEach(function (widget) {
      widget.dataset.init = 'true';
      var input = widget.querySelector('input');
      widget.querySelectorAll('button').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var step = btn.dataset.step === 'up' ? 1 : -1;
          input.value = Math.max(1, (parseInt(input.value, 10) || 1) + step);
        });
      });
    });
  }

  /* --- product gallery ---------------------------------------------- */
  function initGallery(scope) {
    var main = scope.querySelector('[data-gallery-main]');
    if (!main || main.dataset.init) return;
    main.dataset.init = 'true';
    var thumbs = scope.querySelectorAll('[data-gallery-thumb]');
    thumbs.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var img = btn.querySelector('img');
        main.src = btn.dataset.full || img.src;
        main.alt = img.alt;
        thumbs.forEach(function (b) {
          b.setAttribute('aria-current', b === btn ? 'true' : 'false');
        });
      });
    });
  }

  /* --- carousel ------------------------------------------------------ */
  function initCarousel(scope) {
    scope.querySelectorAll('[data-carousel]:not([data-init])').forEach(function (root) {
      root.dataset.init = 'true';

      var vp = root.querySelector('[data-carousel-viewport]');
      var slides = Array.prototype.slice.call(root.querySelectorAll('.carousel__slide'));
      var dots = Array.prototype.slice.call(root.querySelectorAll('[data-carousel-dot]'));
      var prev = root.querySelector('[data-carousel-prev]');
      var next = root.querySelector('[data-carousel-next]');
      if (!vp || slides.length < 2) return;

      var index = 0;
      var timer = null;
      var delay = parseInt(root.dataset.autoplay, 10) || 0;

      function goTo(i) {
        index = Math.max(0, Math.min(slides.length - 1, i));
        vp.scrollTo({
          left: slides[index].offsetLeft - slides[0].offsetLeft,
          behavior: reduced ? 'auto' : 'smooth'
        });
        sync();
      }

      function sync() {
        dots.forEach(function (dot, i) {
          dot.setAttribute('aria-current', i === index ? 'true' : 'false');
        });
        if (prev) prev.disabled = index === 0 && !delay;
        if (next) next.disabled = index === slides.length - 1 && !delay;
      }

      var ticking = false;
      vp.addEventListener('scroll', function () {
        if (ticking) return;
        ticking = true;
        window.requestAnimationFrame(function () {
          index = Math.round(vp.scrollLeft / (vp.clientWidth || 1));
          sync();
          ticking = false;
        });
      }, { passive: true });

      if (prev) prev.addEventListener('click', function () { stop(); goTo(index - 1); });
      if (next) next.addEventListener('click', function () { stop(); goTo(index + 1); });
      dots.forEach(function (dot, i) {
        dot.addEventListener('click', function () { stop(); goTo(i); });
      });

      vp.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowLeft') { e.preventDefault(); stop(); goTo(index - 1); }
        if (e.key === 'ArrowRight') { e.preventDefault(); stop(); goTo(index + 1); }
      });

      function start() {
        if (!delay || reduced || inEditor || timer) return;
        timer = window.setInterval(function () {
          goTo(index + 1 >= slides.length ? 0 : index + 1);
        }, delay);
      }
      function stop() {
        if (timer) { window.clearInterval(timer); timer = null; }
      }

      root.addEventListener('mouseenter', stop);
      root.addEventListener('focusin', stop);
      root.addEventListener('mouseleave', start);
      document.addEventListener('visibilitychange', function () {
        if (document.hidden) { stop(); } else { start(); }
      });

      sync();
      start();
    });
  }

  /* --- boot ---------------------------------------------------------- */
  function initAll(scope) {
    scope = scope || document;
    initReveal(scope);
    initQty(scope);
    initGallery(scope);
    initCarousel(scope);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }

  // Shopify re-renders individual sections in the theme editor — re-init them.
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
  document.addEventListener('shopify:section:select', function (e) { initAll(e.target); });
  document.addEventListener('shopify:block:select', function (e) { initAll(e.target); });
})();
